<script setup lang="ts">
withDefaults(defineProps<{ rows?: number; label: string }>(), { rows: 5 })

const widths = [
  ['38%', '24%'],
  ['30%', '42%'],
  ['44%', '28%'],
  ['26%', '36%'],
  ['34%', '22%'],
]
</script>

<template>
  <div aria-busy="true" :aria-label="label" class="ui-skeleton">
    <div v-for="index in rows" :key="index" class="ui-skeleton__row">
      <div class="ui-skeleton__block ui-skeleton__avatar"></div>
      <div class="ui-skeleton__lines">
        <div class="ui-skeleton__block ui-skeleton__line" :style="{ width: widths[(index - 1) % widths.length]![0] }"></div>
        <div class="ui-skeleton__block ui-skeleton__line ui-skeleton__line--thin" :style="{ width: widths[(index - 1) % widths.length]![1] }"></div>
      </div>
      <div class="ui-skeleton__block ui-skeleton__pill"></div>
    </div>
  </div>
</template>

<style scoped>
.ui-skeleton {
  display: flex;
  flex-direction: column;
}
.ui-skeleton__row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  border-bottom: var(--hairline) solid var(--separator-row);
}
.ui-skeleton__block {
  background: var(--secondary-system-fill);
  animation: aub-pulse 1.4s ease-in-out infinite;
}
.ui-skeleton__avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
}
.ui-skeleton__lines {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ui-skeleton__line {
  height: 12px;
  border-radius: 4px;
}
.ui-skeleton__line--thin {
  height: 10px;
}
.ui-skeleton__pill {
  height: 22px;
  width: 64px;
  border-radius: var(--radius-full);
}
</style>
